var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.612,
    height: 150,
    viewBox: "0 0 147.612 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    d: "M59.9-1A60.9,60.9,0,1,1-1,59.9,60.972,60.972,0,0,1,59.9-1Zm0,107.475A46.573,46.573,0,1,0,13.33,59.9,46.625,46.625,0,0,0,59.9,106.475Z",
    fill: "#fffbf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_58",
    "data-name": "Line 58",
    d: "M43.423,50.588a7.143,7.143,0,0,1-5.066-2.1L1.1,11.231A7.165,7.165,0,0,1,11.231,1.1L48.49,38.357a7.165,7.165,0,0,1-5.066,12.231Z",
    transform: "translate(96.024 98.412)",
    fill: "#fffbf5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.6e9440fd7a521bd7e76d0d09a04401c3.svg";
export { ForwardRef as ReactComponent };